import { compose } from '@doltech/utils/lib/compose';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { useDolStoryStore, withDolStoryStore } from './dol-story.store';
import { StoryCardItem } from './StoryCard';
import { StoryList } from './StoryList';
import { StoryModal } from './StoryModal';

const Main = styled.div``;

interface DolStoryProps {
  data: StoryCardItem[];
}

const DolStoryBase = (props: DolStoryProps) => {
  const { data } = props;
  const store = useDolStoryStore();

  React.useEffect(() => {
    store.registerData(data);
  }, [store, data]);

  React.useEffect(() => {
    const handleKeyDown = (event) => {
      switch (event.key) {
        case 'Down':
        case 'ArrowDown':
          store.closeModal();
          break;

        case 'Left':
        case 'ArrowLeft':
          store.prevSlide();
          break;
        case 'Right':
        case 'ArrowRight':
          store.nextSlide();
          break;
        case 'Enter':
        case 'Esc':
        case 'Escape':
          store.closeModal();
          break;
        default:
      }
    };

    document.addEventListener('keydown', handleKeyDown, { passive: true });

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [store]);

  return (
    <Main className="dol-story">
      <StoryList
        onCardClick={(cardIndex) => {
          store.openModal(cardIndex);
        }}
        data={data}
      />
      <StoryModal
        activeIndex={store.currentActiveIndex}
        visible={store.modalVisible}
        onClose={store.closeModal}
        onNextClick={store.nextSlide}
        onPrevClick={store.prevSlide}
        data={data}
      />
    </Main>
  );
};

export const DolStory = compose(
  withDolStoryStore,
  observer
)(DolStoryBase) as React.FC<DolStoryProps>;
